<template>
  <v-card width="100%" class="fill-height" color="gray10 pr-5 pl-5 pt-2">
    <v-row no-gutters class="justify-md-space-between justify-center">
      <v-col cols="12" class="d-flex justify-space-between align-center">
        <v-tabs
          class="market-tabs"
          height="38"
          background-color="transparent"
          show-arrows
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            class="font-Medium-14"
            v-for="(item, index) in tableTabsItem"
            :key="index"
            @click="() => changeTab(item.value)"
          >
            {{ item.text }}
          </v-tab>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-tab v-bind="attrs" v-on="on" class="font-Medium-14">
                {{ $t("exchange.ordersHistory") }}
                <v-icon
                  size="16"
                  :clr="$vuetify.theme.dark === true ? '#E4E6E9' : '#000022'"
                  class="ms-1"
                >
                  $arrowDown
                </v-icon>
              </v-tab>
            </template>
            <v-list>
              <v-list-item @click="() => changeTab('orders')">
                <v-list-item-title
                  >{{ $t("exchange.orders") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="() => changeTab('preconditionOrders')">
                <v-list-item-title
                  >{{ $t("exchange.preconditionOrders") }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-tabs>
        <v-btn text color="primary" @click="goToHistoryPage">{{
          $t("common.more")
        }}</v-btn>
      </v-col>
      <v-col cols="12" class="mt-4 table-wrapper">
        <!--        openOrders-->
        <v-data-table
          v-if="selectedOrderTab === 'openOrders'"
          :no-data-text="$t('common.nodata')"
          class="custom-price-data-table custom-open-orders-table gray10"
          :loading-text="$t('common.loadingText')"
          :headers="openOrdersColumns"
          :items="openOrdersTableData"
          :loading="openOrdersLoading"
          hide-default-footer
          disable-pagination
          fixed-header
          ref="table"
          style="max-height: 600px;overflow-y: scroll"
        >
          <template v-slot:item.time="{ item }">
            <span>
              {{ item.time | dateFormat }}
            </span>
          </template>
          <template v-slot:item.orderType="{ item }">
            <span>
              {{
                item.source === "STOP_LIMIT_ORDER" ||
                item.source === "STOP_LIMIT_CONDITION"
                  ? $t("exchange.stopLimit")
                  : item.type === "LIMIT_PRICE" &&
                    item.source === "MANUAL_ORDER"
                  ? $t("exchange.limitOrder")
                  : item.type === "MARKET_PRICE" &&
                    item.source === "MANUAL_ORDER"
                  ? $t("exchange.marketOrder")
                  : item.source === "OCO_ORDER"
                  ? $t("exchange.ocoLimit")
                  : item.source === "OCO_STOP_LIMIT_ORDER" ||
                    item.source === "OCO_CONDITION"
                  ? $t("exchange.ocoStopLimit")
                  : "--"
              }}
            </span>
          </template>
          <template v-slot:item.direction="{ item }">
            <span
              :class="{
                'green--text': item.direction == 'BUY',
                'red--text': item.direction == 'SELL'
              }"
            >
              {{
                item.direction === "BUY"
                  ? $t("exchange.buy")
                  : $t("exchange.sell")
              }}
            </span>
          </template>
          <template v-slot:item.price="{ item }">
            <span>
              {{ $thousandMask(item.price) }}
            </span>
          </template>
          <template v-slot:item.amount="{ item }">
            <div>
              <span>{{ item.amount }}</span>
              <span class="me-2 text-sm-subtitle-2">{{ item.coinSymbol }}</span>
            </div>
          </template>
          <template v-slot:item.tradedAmount="{ item }">
            <div>
              <span>{{ item.tradedAmount }}</span>
              <span class="me-2 text-sm-subtitle-2">{{ item.coinSymbol }}</span>
            </div>
          </template>
          <template v-slot:item.percent="{ item }">
            <span>
              {{ item.tradedPercentage + "%" }}
            </span>
          </template>
          <template v-slot:item.averagePrice="{ item }">
            <span>{{ $thousandMask(item.averagePrice) }}</span>
          </template>
          <template v-slot:item.turnover="{ item }">
            <span>{{ item.turnover }}</span>
            <span class="me-2 text-sm-subtitle-2">{{ item.baseSymbol }}</span>
          </template>
          <template v-slot:item.operation="{ item }">
            <v-btn
              class="cancel-btn red--text"
              small
              text
              @click="cancelOrderModalHandler(item.orderId)"
            >
              {{ $t("exchange.undo") }}
            </v-btn>
            <v-btn
              class="table-details-btn ms-2"
              :loading="detailsBtnLoading === item.orderId"
              small
              color="primary"
              text
              @click="getDetails(item)"
            >
              {{ $t("exchange.more") }}
            </v-btn>
          </template>
        </v-data-table>
        <!--orders-->
        <v-data-table
          v-if="selectedOrderTab === 'orders'"
          :no-data-text="$t('common.nodata')"
          class="custom-price-data-table custom-orders-table gray10"
          :headers="ordersHistoryColumns"
          :items="ordersHistoryTableData"
          hide-default-footer
          disable-pagination
          fixed-header
          ref="table"
          style="max-height: 600px;overflow-y: scroll"
        >
          <template v-slot:item.time="{ item }">
            <span>
              {{ item.time | dateFormat }}
            </span>
          </template>
          <template v-slot:item.orderType="{ item }">
            <span>
              {{
                item.type === "MARKET_PRICE" && item.source === "MANUAL_ORDER"
                  ? $t("exchange.marketOrder")
                  : item.type === "LIMIT_PRICE" &&
                    item.source === "MANUAL_ORDER"
                  ? $t("exchange.limit")
                  : item.source === "STOP_LIMIT_ORDER" ||
                    item.source === "STOP_LIMIT_CONDITION"
                  ? $t("exchange.stopLimit")
                  : item.source === "OCO_ORDER"
                  ? $t("exchange.ocoLimit")
                  : item.source === "OCO_STOP_LIMIT_ORDER" ||
                    item.source === "OCO_CONDITION"
                  ? $t("exchange.ocoStopLimit")
                  : "--"
              }}
            </span>
          </template>
          <template v-slot:item.direction="{ item }">
            <span
              :class="{
                'green--text': item.direction == 'BUY',
                'red--text': item.direction == 'SELL'
              }"
            >
              {{
                item.direction == "BUY"
                  ? $t("exchange.buy")
                  : $t("exchange.sell")
              }}
            </span>
          </template>
          <template v-slot:item.price="{ item }">
            <span>
              {{ $thousandMask(item.price) }}
            </span>
          </template>
          <template v-slot:item.amount="{ item }">
            <div>
              <span>{{ item.amount }}</span>
              <span class="me-2 text-sm-subtitle-2">{{ item.coinSymbol }}</span>
            </div>
          </template>
          <template v-slot:item.tradedAmount="{ item }">
            <div>
              <span>{{ item.tradedAmount }}</span>
              <span class="me-2 text-sm-subtitle-2">{{ item.coinSymbol }}</span>
            </div>
          </template>
          <template v-slot:item.averagePrice="{ item }">
            <span>{{ $thousandMask(item.averagePrice) }}</span>
          </template>
          <template v-slot:item.turnover="{ item }">
            <span>{{ item.turnover }}</span>
            <span class="me-2 text-sm-subtitle-2">{{ item.baseSymbol }}</span>
          </template>
          <template v-slot:item.status="{ item }">
            <span
              :class="{
                'red--text': item.status == 'CANCELED',
                'yellow--text': item.status == 'COMPLETED',
                'yellow--text': item.status == 'ORDERED'
              }"
            >
              {{
                item.status == "COMPLETED"
                  ? $t("exchange.finished")
                  : item.status == "ORDERED"
                  ? $t("exchange.ordered")
                  : $t("exchange.canceled")
              }}
            </span>
          </template>
        </v-data-table>
        <!--        stopLimit-->
        <v-data-table
          v-else-if="selectedOrderTab === 'stopLimit'"
          :no-data-text="$t('common.nodata')"
          class="custom-price-data-table custom-stop-limit-table gray10"
          :headers="stopLimitOrdersColumns"
          :items="stopOrdersTableData"
          hide-default-footer
          disable-pagination
          fixed-header
          ref="table"
          style="max-height: 600px;overflow-y: scroll"
        >
          <template v-slot:item.createdDate="{ item }">
            <span>
              {{ item.createdDate | dateFormat }}
            </span>
          </template>
          <template v-slot:item.orderType="{ item }">
            <span>
              {{
                item.type === "MARKET_PRICE" && item.source === "MANUAL_ORDER"
                  ? $t("exchange.marketOrder")
                  : item.type === "LIMIT_PRICE" &&
                    item.source === "MANUAL_ORDER"
                  ? $t("exchange.limit")
                  : item.source === "STOP_LIMIT_ORDER" ||
                    item.source === "STOP_LIMIT_CONDITION"
                  ? $t("exchange.stopLimit")
                  : item.source === "OCO_ORDER"
                  ? $t("exchange.ocoLimit")
                  : item.source === "OCO_STOP_LIMIT_ORDER" ||
                    item.source === "OCO_CONDITION"
                  ? $t("exchange.ocoStopLimit")
                  : "--"
              }}
            </span>
          </template>
          <template v-slot:item.direction="{ item }">
            <span
              :class="{
                'green--text': item.direction == 'BUY',
                'red--text': item.direction == 'SELL'
              }"
            >
              {{
                item.direction == "BUY"
                  ? $t("exchange.buy")
                  : $t("exchange.sell")
              }}
            </span>
          </template>
          <template v-slot:item.activationPrice="{ item }">
            <div class="font-Regular-12">
              {{ $thousandMask(item.activationPrice) }}
              <span class="font-Regular-16">
                <span v-if="item.momentMarketPrice >= item.activationPrice"
                  >=></span
                >
                <span v-else>&#61;&lt;</span>
              </span>
            </div>
          </template>
          <template v-slot:item.orderPrice="{ item }">
            <span>{{ $thousandMask(item.orderPrice) }}</span>
          </template>
          <template v-slot:item.operation="{ item }">
            <v-btn
              class="cancel-btn red--text"
              small
              text
              @click="cancelPreconditionOrderModalHandler(item.id)"
            >
              {{ $t("exchange.undo") }}
            </v-btn>
          </template>
        </v-data-table>
        <!--        preconditionOrders-->
        <v-data-table
          v-if="selectedOrderTab === 'preconditionOrders'"
          :no-data-text="$t('common.nodata')"
          class="custom-price-data-table custom-precondition-orders-table gray10"
          :headers="preconditionsHistoryColumns"
          :items="preconditionsHistoryData"
          hide-default-footer
          disable-pagination
          fixed-header
          ref="table"
          style="max-height: 600px;overflow-y: scroll"
        >
          <template v-slot:item.createdDate="{ item }">
            <span>
              {{ item.createdDate | dateFormat }}
            </span>
          </template>
          <template v-slot:item.orderType="{ item }">
            <span>
              {{
                item.type === "MARKET_PRICE" && item.source === "MANUAL_ORDER"
                  ? $t("exchange.marketOrder")
                  : item.type === "LIMIT_PRICE" &&
                    item.source === "MANUAL_ORDER"
                  ? $t("exchange.limit")
                  : item.source === "STOP_LIMIT_ORDER" ||
                    item.source === "STOP_LIMIT_CONDITION"
                  ? $t("exchange.stopLimit")
                  : item.source === "OCO_ORDER"
                  ? $t("exchange.ocoLimit")
                  : item.source === "OCO_STOP_LIMIT_ORDER" ||
                    item.source === "OCO_CONDITION"
                  ? $t("exchange.ocoStopLimit")
                  : "--"
              }}
            </span>
          </template>
          <template v-slot:item.direction="{ item }">
            <span
              :class="{
                'green--text': item.direction == 'BUY',
                'red--text': item.direction == 'SELL'
              }"
            >
              {{
                item.direction == "BUY"
                  ? $t("exchange.buy")
                  : $t("exchange.sell")
              }}
            </span>
          </template>
          <template v-slot:item.activationPrice="{ item }">
            <div class="font-Regular-12">
              {{ $thousandMask(item.activationPrice) }}
              <span class="font-Regular-16">
                <span v-if="item.momentMarketPrice >= item.activationPrice"
                  >=></span
                >
                <span v-else>&#61;&lt;</span>
              </span>
            </div>
          </template>
          <template v-slot:item.orderPrice="{ item }">
            <span>{{ $thousandMask(item.orderPrice) }}</span>
          </template>
          <template v-slot:item.amount="{ item }">
            <div>
              <span>{{ item.amount }}</span>
              <span class="me-2 text-sm-subtitle-2">{{
                item.symbol.split("/")[0]
              }}</span>
            </div>
          </template>
          <template v-slot:item.status="{ item }">
            <span
              :class="{
                'red--text':
                  item.status == 'CANCELED' || item.status === 'AUTO_CANCELED',
                'yellow--text':
                  item.status == 'COMPLETED' || item.status == 'ORDERED'
              }"
            >
              {{
                item.status == "COMPLETED"
                  ? $t("exchange.finished")
                  : item.status == "ORDERED"
                  ? $t("exchange.ordered")
                  : $t("exchange.canceled")
              }}
            </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <!--    cancel modals-->
    <v-dialog v-model="isCancelOrderModal" width="500">
      <v-card class="pa-4">
        <v-card-text>
          <p class="text-center font-Regular-16">
            {{ $t("exchange.cancelOrder") }}
          </p>
          <p>{{ $t("exchange.cancelOrderConfirmation") }}</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" text @click="cancelOrder">
            {{ $t("exchange.confirm") }}
          </v-btn>
          <v-btn color="primary" text @click="isCancelOrderModal = false">
            {{ $t("exchange.cancel") }}
          </v-btn>
        </v-card-actions>
        <v-btn icon @click="isCancelOrderModal = false" class="modal-close">
          <v-icon clr="var(--v-gray2-base)">$modalClose</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isCancelPreconditionOrderModal" width="500">
      <v-card class="pa-4">
        <v-card-text>
          <p class="text-center font-Regular-16">
            {{ $t("exchange.cancelOrder") }}
          </p>
          <p>{{ $t("exchange.cancelOrderConfirmation") }}</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" text @click="cancelPreconditionOrder">
            {{ $t("exchange.confirm") }}
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="isCancelPreconditionOrderModal = false"
          >
            {{ $t("exchange.cancel") }}
          </v-btn>
        </v-card-actions>
        <v-btn
          icon
          @click="isCancelPreconditionOrderModal = false"
          class="modal-close"
        >
          <v-icon clr="var(--v-gray2-base)">$modalClose</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>
    <!--    detail modal-->
    <v-dialog v-model="isOrderDetailModal" width="500">
      <v-card class="pa-4 gray10">
        <v-card-text class="text-center font-Regular-16">
          {{ $t("exchange.orderDetails") }}
        </v-card-text>
        <v-divider class="mb-4"></v-divider>
        <v-data-table
          class="custom-price-data-table gray10"
          :headers="orderDetailColumns"
          :items="orderDetailsData"
          :no-data-text="$t('common.nodata')"
          hide-default-footer
          disable-pagination
          fixed-header
          ref="table"
          style="max-height: 600px;overflow-y: scroll"
        >
          <template v-slot:item.time="{ item }">
            <span>{{ item.time | dateFormat }}</span>
          </template>
        </v-data-table>
        <v-btn icon @click="isOrderDetailModal = false" class="modal-close">
          <v-icon clr="var(--v-gray2-base)">$modalClose</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { ExchangeService } from "@/services";
import dayjs from "@/utiles/dayjs";
import { mapGetters } from "vuex";
import * as types from "@/store/types";
import $thousandMask from "@/mixins/thousandMask";
import SockJS from "sockjs-client";
import Stomp from "stompjs";

export default {
  data() {
    return {
      cancelOrderId: "",
      skin: "night",
      tableTabsItem: [
        { text: this.$t("exchange.openOrders"), value: "openOrders" },
        { text: this.$t("exchange.stopLimit"), value: "stopLimit" }
      ],
      selectedOrderTab: "openOrders",
      // columns
      openOrdersColumns: [
        {
          text: this.$t("exchange.time"),
          value: "time",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.symbol"),
          value: "symbol",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.orderType"),
          value: "orderType",
          align: "center",
          sortable: false
        },
        {
          text: this.$t("exchange.direction"),
          value: "direction",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.price"),
          value: "price",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.num"),
          value: "amount",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.traded"),
          value: "tradedAmount",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.percent"),
          value: "percent",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.averageTradePrice"),
          value: "averagePrice",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.dealAmount"),
          value: "turnover",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.refCode"),
          value: "trackingCode",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.action"),
          value: "operation",
          align: "center",
          sortable: true
        }
      ],
      stopLimitOrdersColumns: [
        {
          text: this.$t("exchange.time"),
          value: "createdDate",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.symbol"),
          value: "symbol",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.orderType"),
          value: "orderType",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.direction"),
          value: "direction",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.stopPrice"),
          value: "activationPrice",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.price"),
          value: "orderPrice",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.num"),
          value: "amount",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.refCode"),
          value: "trackingCode",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.action"),
          value: "operation",
          align: "center",
          sortable: true
        }
      ],
      ordersHistoryColumns: [
        {
          text: this.$t("exchange.time"),
          value: "time",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.symbol"),
          value: "symbol",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.orderType"),
          value: "orderType",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.direction"),
          value: "direction",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.price"),
          value: "price",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.num"),
          value: "amount",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.done"),
          value: "tradedAmount",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.averageTradePrice"),
          value: "averagePrice",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.dealAmount"),
          value: "turnover",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.refCode"),
          value: "trackingCode",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.status"),
          value: "status",
          align: "center",
          sortable: true
        }
      ],
      preconditionsHistoryColumns: [
        {
          text: this.$t("exchange.time"),
          value: "createdDate",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.symbol"),
          value: "symbol",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.orderType"),
          value: "orderType",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.direction"),
          value: "direction",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.stopPrice"),
          value: "activationPrice",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.price"),
          value: "orderPrice",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.num"),
          value: "amount",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.refCode"),
          value: "trackingCode",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("exchange.status"),
          value: "status",
          align: "center",
          sortable: true
        }
      ],
      orderDetailColumns: [
        {
          text: this.$t("exchange.num"),
          value: "amount",
          align: "center",
          sortable: false,
          minWidth: 100
        },
        {
          text: this.$t("exchange.price"),
          value: "price",
          align: "center",
          sortable: false,
          minWidth: 100
        },
        {
          text: this.$t("exchange.time"),
          value: "time",
          align: "center",
          sortable: false,
          minWidth: 150
        },
        {
          text: this.$t("exchange.turnover"),
          value: "turnover",
          align: "center",
          sortable: false,
          minWidth: 120
        }
      ],

      //   table data
      openOrdersTableData: [],
      ordersHistoryTableData: [],
      stopOrdersTableData: [],
      preconditionsHistoryData: [],

      //   loading table state
      openOrdersLoading: false,
      historyOrdersLoading: false,
      preconditionOrdersLoading: false,
      preconditionsHistoryLoading: false,
      // modals state
      detailsBtnLoading: null,
      isCancelOrderModal: false,
      isCancelPreconditionOrderModal: false,
      isOrderDetailModal: false,
      orderDetailsData: []
    };
  },
  mixins: [$thousandMask],
  filters: {
    dateFormat(date) {
      return dayjs(date).format("YYYY/MM/DD-HH:mm:ss");
    }
  },
  mounted() {
    this.initGetTableData();
  },
  methods: {
    initGetTableData() {
      this.getOpenOrdersData();
      this.getHistoryOrder();
      this.getAllPreconditionOrders();
      this.getPreconditionsHistory();
      this.startOrdersWebsocket();
    },
    startOrdersWebsocket() {
      let stompClient = null;
      let socket = new SockJS(
        `${process.env.VUE_APP_BASE_MARKET}/market/market-ws`
      );
      stompClient = Stomp.over(socket);
      stompClient.debug = false;
      stompClient.connect({}, () => {
        stompClient.subscribe(
          "/topic/market/order-canceled/" +
            this.currentCoin.symbol +
            "/" +
            this.getMarketUserInfo.id,
          () => {
            this.initGetTableData();
          }
        );
        stompClient.subscribe(
          "/topic/market/order-completed/" +
            this.currentCoin.symbol +
            "/" +
            this.getMarketUserInfo.id,
          () => {
            this.initGetTableData();
          }
        );
        stompClient.subscribe(
          "/topic/market/order-trade/" +
            this.currentCoin.symbol +
            "/" +
            this.getMarketUserInfo.id,
          () => {
            this.initGetTableData();
          }
        );
      });
    },
    getOpenOrdersData() {
      this.openOrdersLoading = true;
      const payload = {
        pageNo: 1,
        pageSize: 10,
        symbol: this.$route.params.pair.replace("_", "/")
      };
      this.openOrdersTableData = [];
      ExchangeService.geOrdersCurrentList(payload)
        .then(response => {
          if (response.data.content && response.data.content.length > 0) {
            this.openOrdersTableData = response.data.content;
            this.openOrdersTableData.forEach(row => {
              row.skin = this.skin;
              row.price =
                row.type === "MARKET_PRICE"
                  ? this.$t("exchange.marketPrice")
                  : row.price;
            });
          }
        })
        .finally(() => {
          this.openOrdersLoading = false;
        });
    },
    getHistoryOrder() {
      this.historyOrdersLoading = true;
      this.ordersHistoryTableData = []; //clear data
      let payload = {
        pageNo: 1,
        pageSize: 10,
        symbol: this.$route.params.pair.replace("_", "/")
      };
      ExchangeService.getOrdersHistory(payload)
        .then(response => {
          let rows = [];
          for (let i = 0; i < response.data.content.length; i++) {
            let row = response.data.content[i];
            if (row) {
              row.skin = this.skin;
              row.price =
                row.type == "MARKET_PRICE"
                  ? this.$t("exchange.marketPrice")
                  : row.price;
              rows.push(row);
            }
          }
          this.ordersHistoryTableData = rows;
        })
        .finally(() => {
          this.historyOrdersLoading = false;
        });
    },
    getAllPreconditionOrders() {
      this.preconditionOrdersLoading = true;
      this.stopOrdersTableData = []; //clear data
      let payload = {
        pageNo: 1,
        pageSize: 10,
        symbol: this.$route.params.pair.replace("_", "/")
      };
      ExchangeService.getAllActivePreconditionsService(payload)
        .then(response => {
          this.stopOrdersTableData = response.data.data.content;
        })
        .finally(() => {
          this.preconditionOrdersLoading = false;
        });
    },
    getPreconditionsHistory() {
      this.preconditionsHistoryLoading = true;
      this.preconditionsHistoryData = []; //clear data
      let payload = {
        pageNo: 1,
        pageSize: 10,
        symbol: this.$route.params.pair.replace("_", "/")
      };
      ExchangeService.getAllPreconditionsHistoryService(payload)
        .then(response => {
          let rows = [];
          if (
            response.data.data.content &&
            response.data.data.content.length > 0
          ) {
            // this.historyTablePaginate.total = response.data.data.totalElements;
            // this.historyTablePaginate.page = response.data.data.number + 1;
            for (let i = 0; i < response.data.data.content.length; i++) {
              let row = response.data.data.content[i];
              if (row) {
                row.skin = this.skin;
                row.price =
                  row.type == "MARKET_PRICE"
                    ? this.$t("exchange.marketPrice")
                    : row.price;
                rows.push(row);
              }
            }
            this.preconditionsHistoryData = rows;
          }
        })
        .finally(() => {
          this.preconditionsHistoryLoading = false;
        });
    },
    cancelOrderModalHandler(orderId) {
      this.isCancelOrderModal = true;
      this.cancelOrderId = orderId;
    },
    cancelPreconditionOrderModalHandler(orderId) {
      this.isCancelPreconditionOrderModal = true;
      this.cancelOrderId = orderId;
    },
    cancelOrder() {
      ExchangeService.orderCancel(this.cancelOrderId)
        .then(() => {
          this.$toast.success(this.$t("exchange.successCancel"));
          this.cancelOrderId = "";
          this.isCancelOrderModal = false;
          this.initGetTableData();
        })
        .catch(err => {
          this.$toast.error(err.message);
        });
    },
    cancelPreconditionOrder() {
      ExchangeService.orderPreconditionCancel(this.cancelOrderId)
        .then(() => {
          this.$toast.success(this.$t("exchange.successCancel"));
          this.cancelOrderId = "";
          this.isCancelPreconditionOrderModal = false;
          this.initGetTableData();
        })
        .catch(err => {
          this.$toast.error(err.message);
        });
    },
    getOrderDetails(orderId) {
      this.detailsBtnLoading = orderId;
      ExchangeService.getOrderDetails(orderId)
        .then(response => {
          this.orderDetailsData = response.data.data.detail;
          this.isOrderDetailModal = true;
        })
        .finally(() => {
          this.detailsBtnLoading = null;
        });
    },
    getDetails(data) {
      if (this.detailsBtnLoading !== null) return;
      if (data.source === "MANUAL_ORDER" || data.source === "OCO_ORDER") {
        this.getOrderDetails(data.orderId);
        // } else if (
        //   data.source === "STOP_LIMIT_ORDER" ||
        //   data.source === "OCO_STOP_LIMIT_ORDER"
        // ) {
        //   this.getStopLimitOrderDetail(data.orderId);
      }
    },
    changeTab(value) {
      this.selectedOrderTab = value;
      if (value === "orders") {
        this.$emit("getHistoryOrderData");
      }
    },
    goToHistoryPage() {
      const tabToRoute = {
        openOrders: "/open-orders",
        stopLimit: "/stop-limit-orders",
        orders: "/history/orders-history",
        preconditionOrders: "/history/precondition-orders-history"
      };
      this.$router.push(tabToRoute[this.selectedOrderTab]);
    }
  },
  computed: {
    ...mapGetters({
      currentCoin: types.marketExchange.getters.GET_CURRENT_COIN,
      getMarketUserInfo: types.marketUserInfo.getters.GET_USER_INFO
    })
  }
};
</script>

<style lang="scss" scoped>
.modal-close {
  position: absolute;
  right: 0;
  top: 0;
}

.table-wrapper {
  height: 200px; // or your desired height
  overflow: hidden;
  position: relative;

  ::v-deep .v-data-table {
    height: 100%;
    overflow-y: auto;

    .v-data-table__wrapper {
      overflow-y: auto;
    }

    // Optional: Style the scrollbar
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.2);
      border-radius: 4px;
    }
  }
}

// Keep existing styles
.modal-close {
  position: absolute;
  right: 0;
  top: 0;
}
</style>
